import { useQuery } from '@tanstack/react-query'
import { supabase } from '../api'

const getAsset = async (id: number | string) => {
  const { data, error } = await supabase
    .from('assets')
    .select(`
      *,
      category:categories(*)
    `)
    .eq('id', id)
    .eq('active', true)
    .single()

  if (error) {
    throw new Error(error.message)
  }

  const category = data.category?.name;
  const isStock = category === 'Stocks';
  const isETFs = category === 'ETFs';

  const tmpStats: any = {
    'low today': data?.quote?.low,
    'high today': data?.quote?.high,
    '52 Week low': data?.quote?.fifty_two_week?.low,
    '52 Week high': data?.quote?.fifty_two_week?.high,
    open: data?.quote?.open,
    volume: data?.quote?.volume,
    'Average volume': data?.quote?.average_volume,
    Exchange: data?.quote?.exchange,
  };

  if (!data?.quote?.is_market_open) {
    tmpStats.close = data?.quote?.close;
  }

  if (isStock && data?.stats_finance?.['Stock Outstanding']) {
    const stockOutstanding = data.stats_finance['Stock Outstanding'];
    // eslint-disable-next-line no-unsafe-optional-chaining, operator-assignment
    tmpStats['Market cap'] = stockOutstanding * data?.latest_price?.price;
  }

  if ((isStock || isETFs) && typeof data?.stats_finance?.['Diluted EPS TTM'] === 'number') {
    const dilutedEpsTtm = data.stats_finance['Diluted EPS TTM'];
    // eslint-disable-next-line no-unsafe-optional-chaining, operator-assignment
    tmpStats['Price-Earnings Ratio'] = data?.latest_price?.price / dilutedEpsTtm;
  }

  if (isStock) {
    // eslint-disable-next-line no-unsafe-optional-chaining, operator-assignment
    tmpStats['Dividend yield'] = data?.stats_finance?.['Dividend yield'] * 100;
    tmpStats.Beta = data?.stats_finance?.Beta;
  }
  data.frontStats = tmpStats

  return data
}

export default function useAsset(id: number | string) {
  return useQuery({
    queryKey: ['asset', id],
    queryFn: () => getAsset(id),
    staleTime: 60000,
    enabled: !!id,
  })
}
